if (!customElements.get('wls-static-review')) {
    class WLSStaticReview extends HTMLElement {
      constructor() {
        super();
  
        this.classes = {
          openClass: 'is-open',
          trigger: 'js-wls-static-review-copy-read-more',
          modal: 'js-wls-static-review-modal',
          close: 'js-wls-static-review-modal-close'
        };
      }
  
      connectedCallback() {
        this.initTriggers();
        this.initClose();
      }
  
      initTriggers() {
        const triggers = this.querySelectorAll(`.${this.classes.trigger}`);
  
        triggers.forEach(trigger => {
          trigger.addEventListener('click', () => {
            const review = trigger.closest('.wls-static-review__review');
            const modal = review?.nextElementSibling;
  
            if (modal && modal.classList.contains(this.classes.modal)) {
              modal.classList.add(this.classes.openClass);
              document.body.style.overflow = 'hidden';
            }
          });
        });
      }
  
      initClose() {
        const modals = this.querySelectorAll(`.${this.classes.modal}`);
  
        modals.forEach(modal => {
          const closeBtn = modal.querySelector(`.${this.classes.close}`);
          closeBtn?.addEventListener('click', () => {
            this.closeModal(modal);
          });
  
          modal.addEventListener('click', (e) => {
            if (e.target === modal) {
              this.closeModal(modal);
            }
          });
        });
      }
  
      closeModal(modal) {
        modal.classList.remove(this.classes.openClass);
        document.body.style.overflow = '';
      }
    }
  
    customElements.define('wls-static-review', WLSStaticReview);
  }
  